import type { IOperationResult } from '@hc-frontend/core-utils-business-operation';
import type {
  CommonEventProperties,
  PageViewEvent,
} from '@snowplow/browser-tracker';

import type { TrackingError } from '../../error-definition';
import type { CompleteTrackingRepository } from '../../repositories';

export interface TrackPageViewUC {
  (
    event?:
      | (PageViewEvent & CommonEventProperties<Record<string, unknown>>)
      | undefined,
  ): Promise<IOperationResult<void, TrackingError>>;
}

export function composeTrackPageViewUC({
  pageView,
  setCustomUrl,
}: Pick<
  CompleteTrackingRepository,
  'pageView' | 'setCustomUrl'
>): TrackPageViewUC {
  return (event) => {
    setCustomUrl();
    return pageView(event);
  };
}
